import {
  DEFAULT_TENANT_BRAND_PREFIX,
  defaultTenantNavForSlug
} from "./chunk-56L6GLUK.js";
import {
  customProductSlugFromSuffix
} from "./chunk-OENSNHCR.js";
import {
  defineProduct
} from "./chunk-6UZ4MMYO.js";
import {
  normalizeBrandAccentColor
} from "./chunk-2PN7YULH.js";

// src/tenant-products/serialize.ts
import { createElement } from "react";
function navLinkToSerializable(link) {
  const iconClass = typeof link.icon === "object" && link.icon !== null && "props" in link.icon && typeof link.icon.props?.className === "string" ? link.icon.props.className : "fa-light fa-circle";
  const iconActiveClass = link.iconActive && typeof link.iconActive === "object" && link.iconActive !== null && "props" in link.iconActive && typeof link.iconActive.props?.className === "string" ? link.iconActive.props.className : void 0;
  return {
    key: link.key,
    title: link.title,
    url: link.url,
    iconClass,
    iconActiveClass,
    badge: link.badge,
    secondaryPanel: link.secondaryPanel,
    primaryHubChildKey: link.primaryHubChildKey,
    children: link.children?.map(navLinkToSerializable)
  };
}
function serializableNavToRuntime(links) {
  return links.map((link) => ({
    key: link.key,
    title: link.title,
    url: link.url,
    icon: createElement("i", { className: link.iconClass, "aria-hidden": true }),
    iconActive: link.iconActiveClass ? createElement("i", {
      className: link.iconActiveClass,
      "aria-hidden": true
    }) : void 0,
    badge: link.badge,
    secondaryPanel: link.secondaryPanel,
    primaryHubChildKey: link.primaryHubChildKey,
    children: link.children ? serializableNavToRuntime(link.children) : void 0
  }));
}
function tenantRecordToDefinition(record) {
  return defineProduct({
    id: record.id,
    slug: record.slug,
    label: record.label,
    brandPrefix: record.brandPrefix,
    brandSuffix: record.brandSuffix,
    brandColor: record.brandColor,
    scope: record.scope,
    nav: serializableNavToRuntime(record.nav),
    defaultPath: record.defaultPath
  });
}
function definitionToTenantRecord(def, source, existing) {
  const now = (/* @__PURE__ */ new Date()).toISOString();
  return {
    id: def.id,
    slug: def.slug,
    label: def.label,
    brandPrefix: def.brandPrefix,
    brandSuffix: def.brandSuffix,
    brandColor: normalizeBrandAccentColor(def.brandColor),
    scope: def.scope,
    nav: def.nav.map(navLinkToSerializable),
    defaultPath: def.defaultPath,
    source: existing?.source === "user" ? "user" : source,
    createdAt: existing?.createdAt ?? now,
    updatedAt: now,
    deletedAt: existing?.deletedAt ?? null,
    extensions: existing?.extensions ?? {}
  };
}
function brandToTenantRecord(input) {
  const suffix = input.suffix.trim();
  const slug = customProductSlugFromSuffix(suffix);
  const id = input.id ?? `tenant-${slug}`;
  const now = (/* @__PURE__ */ new Date()).toISOString();
  return {
    id,
    slug,
    label: `Exxat ${suffix}`,
    brandPrefix: DEFAULT_TENANT_BRAND_PREFIX,
    brandSuffix: suffix,
    brandColor: normalizeBrandAccentColor(input.brandColor),
    scope: "school-program",
    nav: defaultTenantNavForSlug(slug),
    defaultPath: `/${slug}/dashboard`,
    source: "user",
    createdAt: now,
    updatedAt: now,
    extensions: {}
  };
}

export {
  serializableNavToRuntime,
  tenantRecordToDefinition,
  definitionToTenantRecord,
  brandToTenantRecord
};
